import React from 'react';
import Featured from '../components/Featured';
import Hero from '../components/Hero';
import WhyLehumo from '../components/WhyLehumo';

function home() {

    document.title = "Lehumo - Building Wealth with Digital Assets";
    return (
        <div>
            <Hero />
            <Featured />
            <WhyLehumo />
        </div>
    )
}

export default home